<div style="min-width: 180px">
  <label class="fw-bold mt-sm-max-4"
         [translate]="'common.enterPostCode'"></label>
  <div class="input-group">
    <div class="input-group-prepend">
      <i class="icon-search"></i>
    </div>
    <ui-input-loader-wrap [loading]="busy">
      <input class="form-control"
             type="text"
             placeholder="{{'common.postNumberPlaceholder_' + countryCode | translate}}"
             (keydown.enter)="$event.preventDefault(); foundCityName ? submit() : null;"
             [(ngModel)]="postNumber"
             [inputMask]="'postNumber'"
             [inputMaskArgs]="{countryCode: countryCode}"
             (ngModelChange)="onPostNumberUpdated$.next(postNumber)">
    </ui-input-loader-wrap>
  </div>
  <div *ngIf="foundCityName" class="mt-3 mt-sm-max-3">
    <div class="fw-bold found-city text-center">{{foundCityName}}</div>
    <div class="mt-1 mt-xs-max-2">
      <button class="btn btn-primary btn-pink btn-slim w-100 d-md-inline-block d-none"
              (click)="$event.preventDefault(); submit()"
              [translate]="'orderProcess.cakesOverview.postNumberDeliveryCheck.showProducts'">
      </button>
      <button class="btn btn-primary btn-pink btn-lg w-100 d-md-none"
              (click)="$event.preventDefault(); submit()"
              [translate]="'orderProcess.cakesOverview.postNumberDeliveryCheck.showProducts'">
      </button>
    </div>
  </div>
  <div *ngIf="!foundCityName && isReady"
       class="mt-3"
       [translate]="'orderProcess.cakesOverview.postNumberDeliveryCheck.cityNotFound'">
  </div>
</div>
